import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { HemisphereLight } from "three";
import { DEFAULT_POINT_LIGHT_PARAMS } from "../../../core/lights/HemisphereLight";
export class HemisphereLightSopOperation extends BaseSopOperation {
  static type() {
    return "hemisphereLight";
  }
  cook(inputCoreGroups, params) {
    const light = this.createLight();
    this.updateLightParams(light, params);
    this.updateLightParams(light, params);
    return this.createCoreGroupFromObjects([light]);
  }
  createLight() {
    var _a;
    const light = new HemisphereLight();
    light.name = `HemisphereLight_${((_a = this._node) == null ? void 0 : _a.name()) || ""}`;
    light.matrixAutoUpdate = false;
    light.updateMatrix();
    light.color.copy(DEFAULT_POINT_LIGHT_PARAMS.skyColor);
    light.groundColor.copy(DEFAULT_POINT_LIGHT_PARAMS.groundColor);
    return light;
  }
  updateLightParams(light, params) {
    light.color.copy(params.skyColor);
    light.groundColor.copy(params.groundColor);
    light.intensity = params.intensity;
  }
}
HemisphereLightSopOperation.DEFAULT_PARAMS = DEFAULT_POINT_LIGHT_PARAMS;
HemisphereLightSopOperation.INPUT_CLONED_STATE = InputCloneMode.NEVER;
